import { Button, Spinner } from '@acpaas-ui/react-components';
import PropTypes from 'prop-types';
import Accordion from '../core/accordion/Accordion';
import AccordionTab from '../core/accordion/AccordionTab';
import AccordionTabContent from '../core/accordion/AccordionTabContent';
import AccordionTabHeader from '../core/accordion/AccordionTabHeader';

const DossierSectionWrapper = ({
  className = '',
  title,
  items,
  openedItemIds = [],
  headerClass = 'dossier-section',
  onItemHeaderClick,
  noItemsLabel = 'Er zijn momenteel nog geen items toegevoegd.',
  onAddItem,
  addLabel = 'Toevoegen',
  isAdding
}) => {
  return (
    <div className={`spo-o-dossier-section-wrapper ${className}`}>
      {(title || onAddItem) && (
        <div className="spo-o-dossier-section-wrapper__header u-margin-bottom">
          {title && <h6>{title}</h6>}
          {onAddItem && (
            <Button
              size="small"
              iconRight={isAdding ? undefined : 'ai-add'}
              onClick={onAddItem}
              className={isAdding ? 'loading has-icon-right' : ''}
              disabled={isAdding}
            >
              {addLabel}
              {isAdding ? <Spinner size="small" /> : ''}
            </Button>
          )}
        </div>
      )}
      <Accordion>
        {items?.length ? (
          items?.map((i, index) => (
            <AccordionTab
              headerClass={headerClass}
              key={index}
              open={openedItemIds.includes(i.id)}
              onClick={(isOpen) => onItemHeaderClick(isOpen, i.id)}
            >
              <AccordionTabHeader className={headerClass}>{i.title}</AccordionTabHeader>
              <AccordionTabContent>{i.Component}</AccordionTabContent>
            </AccordionTab>
          ))
        ) : (
          <p className="spo-o-dossier-section-wrapper__no-items u-text-light">{noItemsLabel}</p>
        )}
      </Accordion>
    </div>
  );
};

DossierSectionWrapper.propTypes = {
  title: PropTypes.string,
  onAddItem: PropTypes.func,
  addLabel: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      Component: PropTypes.node.isRequired
    })
  )
};
export default DossierSectionWrapper;
